import { ChangeDetectionStrategy, Component, output, OutputEmitterRef } from '@angular/core';
import { ButtonComponent } from '@libs/common/components';
import { QuickOrderAddTab } from '@libs/shop/models';

@Component({
  selector: 'ui-quick-order-initial',
  templateUrl: './quick-order-initial.component.html',
  styleUrls: ['./quick-order-initial.component.scss'],
  imports: [
    ButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickOrderInitialComponent {
  public readonly tabSelected: OutputEmitterRef<QuickOrderAddTab> = output();
}
